import React from 'react';
import { ICurrensy } from '../../mechanics/inventory/Inventory';
import ImgWithFallback from '../ui/ImgWithFallback';

interface ICurrensyItemProps {
    item: ICurrensy
}

const InventoryCurrensyItem = ({ item }: ICurrensyItemProps) => {
    const { name, images, amount } = item

    return (
        <li className="inventory__body-currensy-item">
            <p>{name}</p>
            <div className='currensy-icon adaptive-img-contain'>
                <span>{amount}</span>
                <ImgWithFallback
                    src={images.webp}
                    fallbackSrc={images.img} />
            </div>
        </li>
    );
};

export default InventoryCurrensyItem;